/**
 * Mirror of IntegralAPI.Domain.Constants.RoleNames.
 *
 * Keep this file in sync with the C# constants when roles are renamed/added.
 * Use these constants instead of hardcoding role-name strings in hasRole(...)
 * checks, route meta, or menu v-if guards — silent drift between Vue and the
 * backend permission system is the failure mode this guards against.
 */
export const RoleNames = Object.freeze({
  // Generic / cross-module
  SuperAdmin:  "SuperAdmin",
  Admin:       "Admin",
  Manager:     "Manager",
  User:        "User",
  Accountant:  "Accountant",
  StoreKeeper: "StoreKeeper",

  // JC (Job Consultancy)
  JcSuperAdmin: "JcSuperAdmin",
  JcAdmin:      "JcAdmin",
  JcStaff:      "JcStaff",
  JcEmployer:   "JcEmployer",
  JcSeeker:     "JcSeeker",
  JcPanelist:   "JcPanelist",
  JcRecruiter:  "JcRecruiter",
  JcSales:      "JcSales",

  // TP (Transport)
  TpAdmin:      "TpAdmin",
  TpManager:    "TpManager",
  TpOperator:   "TpOperator",
  TpDriver:     "TpDriver",
  TpDispatcher: "TpDispatcher",
  TpBilling:    "TpBilling",

  // MM (Matrimony)
  MmSuperAdmin:    "MmSuperAdmin",
  MmAdmin:         "MmAdmin",
  MmStaff:         "MmStaff",
  MmCandidate:     "MmCandidate",
  MatrimonyVendor: "MatrimonyVendor",
  MmCounselor:     "MmCounselor",
  MmBilling:       "MmBilling",
});

export default RoleNames;
